import React, { createContext, useState, useContext, useEffect } from 'react';

const ServiceContext = createContext();

export const useSelectedService = () => useContext(ServiceContext);

// --- 암호화/복호화 함수 (Base64 사용) ---
function encode(str) {
    // btoa는 UTF-8 문자를 처리하지 못할 수 있으므로, 인코딩 과정을 추가합니다.
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, (match, p1) => {
        return String.fromCharCode('0x' + p1);
    }));
}

function decode(str) {
    try {
        const decoded = atob(str);
        return decodeURIComponent(decoded.split('').map(c => {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    } catch (e) {
        console.error("Failed to decode session data", e);
        return null;
    }
}

export const ServiceProvider = ({ children }) => {
    // 현재 선택된 서비스 객체를 상태로 관리합니다. 초기값은 로컬 스토리지에서 가져옵니다.
    const [selectedService, setSelectedService] = useState(() => {
        try {
            const encryptedSession = localStorage.getItem('selectedService');
            if (!encryptedSession) {
                return null;
            }
            const decryptedSessionStr = decode(encryptedSession);
            if (!decryptedSessionStr) {
                return null;
            }
            return JSON.parse(decryptedSessionStr);
        } catch (e) {
            return null;
        }
    });

    // selectedService가 변경될 때마다 로컬 스토리지에 저장합니다.
    useEffect(() => {
        if (selectedService) {
            const sessionStr = JSON.stringify(selectedService)
            const encryptedSession = encode(sessionStr);
            localStorage.setItem('selectedService', encryptedSession);
        } else {
            localStorage.removeItem('selectedService');
        }
    }, [selectedService]);

    const value = { selectedService, setSelectedService };

    return (
        <ServiceContext.Provider value={value}>
            {children}
        </ServiceContext.Provider>
    );
};